<template>
  <div>
    <van-tabbar v-model="active" active-color="#FBAC01">
 
  <van-tabbar-item icon="home-o"  @click="mianfanghome">面访签到</van-tabbar-item>
  <van-tabbar-item icon="friends-o" @click="mianfangjilu">面访记录</van-tabbar-item>
</van-tabbar>
  </div>
</template>

<script>
export default {
  props: {
    active: {
        type: Number,
          default: '',
        
      },
  },
    data() {
    return {
      // activenew:0,
    };
  },
  methods:{
    mianfanghome(){
      this.$router.push({path:'/qiwei/mianqian'})
    },
    mianfangjilu(){
      this.$router.push({path:'/qiwei/interviewinglog'})
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/pages/qiwei/component/fooalt.vue